import { useAppDispatch, useAppSelector } from "../../../redux/store";
import {
    changeOrderView,
    changeState,
    getOldestOrderDateByStateId,
    getOrders,
    getOrdersStatesSummary
} from "../../../redux/slices/orders-slice";
import React, { useEffect } from "react";
import { useNavigate, useOutletContext } from "react-router-dom";
import { NavigationItem } from "./item/navigation-item";
import { OutletContext } from "../../../router/router";
import { SidebarItem } from "../../../redux/reducers/sidebar-reducers";
import { OrderViewEnum } from "../../orders/enums/order/view.enum";
import { changeSidebarIsOpen } from "../../../redux/slices/sidebar.slice";

export const Navigation = React.memo(({ inOrders, withNavigate, items }: NavigationProps) => {
    const { inWarehouseStateId } = useAppSelector(state => state.staticDataReducer);
    const { typeId, orderStateId, ordersStateSummary, oldestInWarehouseOrderDate } = useAppSelector(state => state.ordersReducer);

    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const outletContext = useOutletContext<OutletContext>();

    useEffect(() => {
        if (!outletContext.isAdmin) {
            dispatch(getOrdersStatesSummary());
            dispatch(getOldestOrderDateByStateId(inWarehouseStateId));
        }
    }, [inOrders, typeId, orderStateId])

    const onTabChange = (selectedTypeId: number) => {
        // TODO: Disabled until sent tab is added
        // if (typeId !== selectedTypeId || !inOrders) {
        //     dispatch(changeTab(selectedTypeId));
        //     dispatch(getOrders(0));
        //
        //     navigate('/orders/my');
        // }
    }

    const onStateFilterChange = (selectedStateId: number | string) => {
        if (orderStateId !== selectedStateId || !inOrders || withNavigate) {
            dispatch(changeState(selectedStateId));
            dispatch(changeSidebarIsOpen(false));
            
            switch (selectedStateId) {
                case 'dashboard':
                    navigate('../management/dashboard');

                    break;
                case 'warehouseDashboard':
                    navigate('../management/warehouse-orders/dashboard');

                    break;
                case 'additionalServices':
                    navigate('./additional-services');

                    break;
                case 'customers':
                    navigate('../management/customers');

                    break;
                case 'allOrders':
                    navigate('../management/all-orders');

                    break;
                case 'warehouseWorkers':
                    navigate('../management/warehouse-workers');

                    break;
                case 'warehouses':
                    navigate('../management/warehouses');

                    break;
                case 'messages':
                    navigate('../management/messages');

                    break;
                case 'staticValues':
                    navigate('../management/static-values');

                    break;
                case 'history':
                    navigate('../management/history');

                    break;
                case 'mobileOrders':
                    navigate('../management/pdr/orders');

                    break;

                case 'mobileUsers':
                    navigate('../management/pdr/users');

                    break;
                default:
                    dispatch(getOrders({ page: 0 }));

                    const isInOrderListPage = location.pathname.endsWith('/my')

                    if (outletContext.isWarehouseWorker || outletContext.isLocalWarehouseWorker) {
                        dispatch(changeOrderView(OrderViewEnum.list));
                    }

                    if (!inOrders || withNavigate || !isInOrderListPage) {
                        if (outletContext.isWarehouseWorker) {
                            navigate('../management/warehouse-orders/my');
                        } else if (outletContext.isLocalWarehouseWorker) {
                            navigate('../management/local-warehouse-orders/my');
                        } else {
                            navigate('../orders/my');
                        }
                    }
                    break;
            }
        }
    }

    return (
        <>
            {/*<TabButtonContainer>*/}
            {/*    <BarekamButton onClick={() => onTabChange(orderTypes[0]?.orderTypeId)}*/}
            {/*                   selected={typeId === orderTypes[0]?.orderTypeId}*/}
            {/*                   type={"received"}>*/}
            {/*        <BarekamText variant={"xl"}>*/}
            {/*            <Message messageKey={'awaiting'} sectionId={MessageSections.MAIN}/>*/}
            {/*        </BarekamText>*/}
            {/*    </BarekamButton>*/}

            {/*<BarekamButton clickAction={() => onTabChange(orderTypes[1]?.orderTypeId)}*/}
            {/*               selected={inOrders && typeId === orderTypes[1]?.orderTypeId}*/}
            {/*               actionBarType={"sent"}>*/}
            {/*    <BarekamText customInputVariant={"xl"}>sent</BarekamText>*/}
            {/*</BarekamButton>*/}
            {/*</TabButtonContainer>*/}

            {items.map(item =>
                <NavigationItem name={item.name}
                    itemId={item.id}
                    countable={item.countable}
                    onClick={() => onStateFilterChange(item.id)}
                    inOrders={inOrders}
                    key={item.id} />
            )}
        </>
    );
});

interface NavigationProps {
    inOrders: boolean,
    withNavigate: boolean,
    items: SidebarItem[]
}